var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutter90Rotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.83 21.38L29.34 26h40l4.81-6H34.34l-12.51 1.38zm0 10h40l4.81-6h-32.3l-12.51 6zm0 10h40l4.81-6h-32.3l-12.51 6zm0 10h40l4.81-6h-32.3l-12.51 6zM10.88 38.34V38h5.5l-7.5-7.5-7.5 7.5h5.5v.42a19 19 0 0019 18.87v-4a15 15 0 01-15-14.95z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_90_rotation.154399e8.svg";
export { SvgC1RollerShutter90Rotation as ReactComponent };